//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'inputbox',
    inheritAttrs: true,
    props: {
        value: {
            default: '',
        },
        boxType: {
            default: '',
            type: String,
        },
        size: {
            default: 'large',
            type: String,
        },
        normal: {
            default: 'auto',
            type: String,
        }
    },
    methods: {
        oninput(e){
            this.$emit('input',e.target.value);
        },
        onblur(){
            this.$emit('blur',this.value);
        },
        onfocus(){
            this.$emit('focus',this.value);
        },
        onclick(){
            this.$emit('click',this.value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/inputbox.vue